<div class="row">
  <div class="col-12 col-lg-6">
    <app-button [buttonCssClass]="'button button-left button-black float-left'" [title]="'Add' | translate" (click)="addChild()"></app-button>
  </div>
</div>
